import { saveSplashBranding } from 'waldur-boot-splash';
import { initBrandTokens, initFontFamily } from 'waldur-design-tokens';

import { ENV } from './core/config';
import { initMatomoTracker } from './core/matomo';
import { initSentry } from './core/sentry';
import { configureHomeportTableHost } from './core/tableHost';
import { getBrandColor } from './core/utils';
import { translate } from './i18n';
import {
  initLanguageUtils,
  LanguageUtilsService,
} from './i18n/LanguageUtilsService';
import { attachTransitions } from './transitions';

function initCssVariables() {
  initBrandTokens(getBrandColor());

  initFontFamily(ENV.plugins.WALDUR_CORE.FONT_FAMILY || 'Inter');
}

function initPageTitle() {
  document.title = ENV.plugins.WALDUR_CORE.FULL_PAGE_TITLE;
}

function initI18n() {
  initLanguageUtils();
  LanguageUtilsService.checkLanguage();
}

/**
 * Composes the init* steps above in order. Split out so each concern
 * (analytics, error tracking, i18n, router transitions, brand CSS
 * variables) can be reasoned about and changed independently, and so a
 * future standalone auth app has a clear, small set of steps to copy
 * rather than one monolithic function to pick apart.
 */
export function afterBootstrap() {
  initPageTitle();
  initMatomoTracker();
  initSentry();
  initI18n();
  attachTransitions();
  configureHomeportTableHost();
  initCssVariables();
  // Fire and forget: only the next visit's splash depends on it. Once the
  // user's language has loaded, so the splash text is cached in it.
  const core = ENV.plugins?.WALDUR_CORE;
  if (core) {
    void LanguageUtilsService.whenLoaded().then(() =>
      saveSplashBranding(core, { translate }),
    );
  }
}
